import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M13.79 20.935A6.97 6.97 0 0 0 15 17a6.97 6.97 0 0 0-1.254-4 6 6 0 0 1 5.579 4.068l.295.867c.217.64-.073 1.34-.68 1.64a13.4 13.4 0 0 1-5.15 1.36M17 7a4 4 0 1 1-8 0 4 4 0 0 1 8 0"
    }
  ),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      fillRule: "evenodd",
      d: "M8 22a5 5 0 1 0 0-10 5 5 0 0 0 0 10m1-8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-2 3a1 1 0 1 1 2 0v2a1 1 0 1 1-2 0z",
      clipRule: "evenodd"
    }
  )
);
var SvgContactInfoFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ContactInfoFilled_default = SvgContactInfoFilled;

export { ContactInfoFilled_default as default };
